import { render, staticRenderFns } from "./OtherInModal.vue?vue&type=template&id=b4f54286&scoped=true"
import script from "./OtherInModal.vue?vue&type=script&lang=js"
export * from "./OtherInModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4f54286",
  null
  
)

export default component.exports